/** @module Enums */ /** typedoc */
var AccountingStatusEnum;
(function (AccountingStatusEnum) {
    /**
     * Customer is in good standing. There are no overdue invoices or payment issues.
     */
    AccountingStatusEnum["Good"] = "Good";
    /**
     * Customer is in poor standing. One or more invoices are overdue
     * and if they are a credit card customer, there may be a failed
     * collection attempt.
     *
     * Some will appear with ( ) after the PoorStanding status.  This
     * represents the number of grace period days left before this customer
     * will move into a Service Status of Suspended (see Configuring Billing
     * for more detail on Grace Period)
     */
    AccountingStatusEnum["PoorStanding"] = "PoorStanding";
    /**
     * Customer was manually placed into Collections mode. Collection state
     * would need to be manually removed to place customer back to a Good or
     * PoorStanding state. The Collection state provides you an easier way
     * to distinguish customer accounts in very poor standing or those that
     * may have other issues.
     *
     * It can help to identify a customer with an outstanding balance as
     * forwarded to an external collection agency.
     */
    AccountingStatusEnum["Collection"] = "Collection";
})(AccountingStatusEnum || (AccountingStatusEnum = {}));

export { AccountingStatusEnum };
